// This API key is authorized for using the Google Maps JavaScript API and the Google Places API,
// from Change.org domains only.
// deepcode ignore HardcodedNonCryptoSecret: client-side token that is restricted to our domains.
export const googleMapsApiClientKey = 'AIzaSyDQ1uy2YJMn6Tj3ezShpeBNTk0kWUcEshM';
